<template lang="pug">
#custom-fields.d-flex.align-items-end.p-relative
  ValidationObserver(
    v-slot="{ invalid, errors }"
    slim
  )
    .form-group.m-0.flex-1(:class="{ 'has-error': invalid || hasApiErrors }")
      label.control-label.required
        span.mr-10 Every
        abbr(title="required") *
      .d-flex
        ValidationProvider(
          slim
          rules="required|integer|gte:1"
          name="interval"
          :model-value="interval"
        )
          AppInput#custom-interval.mr-5(
            :value="interval"
            type="number"
            :min.prop="1"
            :disabled="isJobInThePast"
            @input="onIntervalInput"
          )
        ValidationProvider(
          slim
          name="repeatType"
          rules="required"
          :model-value="repeatType"
        )
          AppSelect#custom-repeat-type.ml-5(
            :value="repeatType"
            :disabled="isJobInThePast"
            :options="customRepeatOptions"
            :select2-options="select2Options"
            @input="onSelect"
          )
        .a-errors.has-error(v-show="invalid || hasApiErrors")
          template(
            v-if="errors && errors.repeatType && errors.interval && (errors.repeatType.length || errors.interval.length)"
          )
            template(v-for="(errs, errsIndex) in errors" :key="`errs-${errsIndex}`")
              span.help-block(
                v-for="(err, index) in errs"
                :key="`${err}-${index}`"
              ) {{ err }}
          template(v-if="hasApiErrors")
            span.help-block(
              v-for="(err, index) in customErrors"
              :key="`${err}-${index}`"
            ) {{ err }}
</template>

<script>
import { get } from 'lodash-es';
import { JOB_REPEAT_TYPE } from '~/app_constants';

export default {
  name: 'RecurringJobCustomFields',
  inject: ['isJobInThePast'],
  props: {
    interval: {
      type: Number,
      required: true,
    },
    repeatType: {
      type: String,
      required: true,
    },
    select2Options: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['input'],
  computed: {
    customErrors() {
      const repeatErrors = get(this.errors, 'repeat_type', []);
      const intervalErrors = get(this.errors, 'interval', []);

      return [...repeatErrors.map((re) => `repeat type ${re}`), ...intervalErrors.map((ie) => `interval ${ie}`)];
    },
    hasApiErrors() {
      return !!this.customErrors.length;
    },
    customRepeatOptions() {
      return [
        { id: JOB_REPEAT_TYPE.Weekly, text: this.$filters.pluralize(this.interval, 'Week') },
        { id: JOB_REPEAT_TYPE.Monthly, text: this.$filters.pluralize(this.interval, 'Month') },
        { id: JOB_REPEAT_TYPE.Yearly, text: this.$filters.pluralize(this.interval, 'Year') },
      ];
    },
  },
  methods: {
    onSelect(value) {
      this.$emit('input', { interval: this.interval, repeatType: value });
    },
    onIntervalInput(value) {
      this.$emit('input', { interval: ~~value, repeatType: this.repeatType });
    },
  },
};
</script>
